$( document ).ready(function() {

  /* COOCKIES BANNER */
  checkForBanner();

  if(CID == "NONE"){
    //$(".iWishAdd.button").addClass("d-none");
  }
  

  if (document.getElementById('load-more-button')) {
  load_more_products();
  setupInfiniteScroll();
  setupCollectionBackRestore();
}
  if (document.querySelector('#AddToCart, product-form, .product-form')) observeFirstAvailableProductOption();

  /*if(window.location.href.includes(".com/pt-pt")){
    let path = window.location.href.split("pt-pt");
    path = path[1]
    
    window.location.href = "https://www.giannikavanagh.com/pt-pt"+path;
  }*/

  var customerTags = "bf";
  $("#submit_bf_btn").click(function(){
    customerTags = customerTags + "," + $(".gender_picker input:checked").attr("value") + "," + $("#birth_date").val();
    
    $(".customer_tags").val(customerTags)
  
    $("#newsletter-form").submit();
  })
  
  if($(".section-complete_the_look .product-list__inner .product-item").length){
    
    $(".complete_the_look").removeClass("d-none")
  }

  if($(".buy_as_set .combination_set_form").length){
    $(".buy_as_set").removeClass("d-none")
  }
  

  if($(".shopify-section--main-product").length ){
    
    $(".product-sticky-form__variants .combo-box").change(function(){
      
      let var_selected = $(".combo-box__option-list button[aria-selected=true]").attr("value");
      $(".product-form__option-selector .variants__ .block-swatch input[value="+var_selected+"]").parent().find("label.block-swatch__item").click();
    })
  }

  /*******************************/
   /*** COLLECTIONS LOOK LOGICS ***/
   /*******************************/

  if(window.location.href.includes("?look") && $(".shopify-section--main-product").length > 0){
    
    let look = window.location.href.split("?")[1];
    let count = look.split("&")[1]
    
    look = look.split("&")[0];
    
    let lang = "";
    let back_to_look = "";
    if(window.location.href.includes("/pt")){
      lang = "/pt"
      if(look.includes("for-men")){
        back_to_look = "Voltar para o "+look.replaceAll("-", " ").replace("l", "L").replace("for","para").replace("men","Homen")
      }else{
        back_to_look = "Voltar para o "+look.replaceAll("-", " ").replace("l", "L").replace("for","para").replace("women","Mulher")
      }
    }else if (window.location.href.includes("/es")){
      lang = "/es"
      if(look.includes("for-men")){
        back_to_look = "Volver a "+look.replaceAll("-", " ").replace("l", "L").replace("for","para").replace("men","Hombre")
      }else{
        back_to_look = "Volver a "+look.replaceAll("-", " ").replace("l", "L").replace("for","para").replace("women","Mujer")
      }
    }else if (window.location.href.includes("/fr")){
      lang = "/fr"
      if(look.includes("for-men")){
        back_to_look = "Retour au "+look.replaceAll("-", " ").replace("l", "L").replace("for","pour").replace("men","Homme")
      }else{
        back_to_look = "Retour au "+look.replaceAll("-", " ").replace("l", "L").replace("for","pour").replace("women","Femme")
      }
    }else{
      lang = ""
      if(look.includes("for-men")){
        back_to_look = "Back to "+look.replaceAll("-", " ").replace("l", "L").replace("men","Men")
      }else{
        back_to_look = "Back to "+look.replaceAll("-", " ").replace("l", "L").replace("women","Women")
      }
    }

    //console.log(back_to_look)
  
    let svg_arrow_left = `<svg focusable="false" width="15px" height="15px" class="{{ icon_class }}" viewBox="0 0 17 14">
        <path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="{{ settings.icon_stroke_width }}" fill="none"></path>
      </svg>`;
    
    let html = `<a class="breadcrumb__link" href="`+lang+`/collections/`+look+`?`+count+`">`+look.replace("-", " ").replace("l", "L") +`</a>`;
    let html2 = `<div class="my-3"><a class="breadcrumb__link" style="text-align:right" href="`+lang+`/collections/`+look+`?`+count+`"><h5> `+svg_arrow_left + `<span class="back_to_look">`+ back_to_look +`</span></h5></a></div>`
    $(".breadcrumb__item.look-breadcrumb").append(html);
    $(html2).insertBefore($(".product-meta__vendor"));
    $(".breadcrumb__item.look-breadcrumb").removeClass("d-none");
  }

  let url_count = window.location.href;
  if(url_count.includes("count=")){
    url_count = url_count.split("?")[1];

    $(".product-item-content").each(function(){
      let handle = $(this).find(".product-image a").attr("href")
      $(this).find(".product-image a").attr("href",handle+"&"+url_count )
      $(this).find(".product-item-meta a").attr("href",handle+"&"+url_count )
      $(this).find(".prod-item-title a").attr("href",handle+"&"+url_count )  
    })
    
    
    let url_count_value = url_count.split("=")[1]
    let look_number = $(".collection_title h2").attr("data-look");
    
    
    if(parseInt(look_number) == parseInt(url_count_value)){
      $(".collection_title .next_look").addClass("d-none");
    }else if(parseInt(look_number) == 1){
      $(".collection_title .previous_look").addClass("d-none");
    }
    
    let previous_look = parseInt(look_number)-1;
    let next_look = parseInt(look_number)+1;
    
    let gender = "men"
    if(window.location.href.includes("-for-men")){
      gender = "men"
    }else if(window.location.href.includes("-for-women")){
      gender = "women"
    }

    let previous_url = lang+"/collections/look-"+previous_look+"-for-"+gender+"?count="+url_count_value;
    let next_url = lang+"/collections/look-"+next_look+"-for-"+gender+"?count="+url_count_value;
    
    /*$(".previous_look").attr("href",previous_url)
    $(".next_look").attr("href",next_url)*/

    $(".next_look").click(function(){
      window.location.assign("https://preorders.giannikavanagh.com/"+next_url)
    })

    $(".previous_look").click(function(){
      window.location.assign("https://preorders.giannikavanagh.com/"+previous_url)
    })
  
    $(".collection_title").removeClass("d-none")
  }else{
    $(".collection_title").removeClass("d-none")
  }
  
  if( CID != "" && CID != "NONE"){
    
    wishlistCount()   

    
  }else{
    $(".wishlist_count").addClass("d-none")
  }

  setTimeout(function(){
    changeAddCartBtn();
    selectFirstAvailableProductOption();
  },500)

  $(".product-item__quick-form .product-item__quick-buy-button").click(function(){
    setTimeout(function(){
      changeAddCartBtn();
      selectFirstAvailableProductOption();
    },500)
  });

  

  $(".iWishAddColl, .iWishAdd").click(function(){
    console.log("ddwdwdw")
    setTimeout(function(){
      if(CID != "" || CID != "NONE"){
        wishlistCount()   
      }
    },500)
  })
  
  

  $(".set_product .block-swatch__radio").each(function(){
    if($(this).attr("checked")){
      $(this).click();
      return;
    }
  })
    
  $(".main_product .block-swatch__radio").click(function(){
    $(".main_product .block-swatch__radio").removeAttr("checked")
    $(this).attr("checked", "checked");
  })

  $(".set_product .block-swatch__radio").click(function(){
    $(".set_product .block-swatch__radio").removeAttr("checked")
    $(this).attr("checked", "checked");
  })

    
  $('.add-to-cart-button').click(function() {

    var main_prod_id = $(".main_product .block-swatch input:checked").attr("data-v-id");
    var set_prod_id = $(".set_product .block-swatch input:checked").attr("data-v-id");

    var itemsData = [
      {
        id: main_prod_id,
        quantity: 1
      },
      {
        id: set_prod_id,
        quantity: 1
      }
    ];

    var data = {
      items: itemsData
    };

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(response) {
        console.log('Product added to cart successfully!');
        console.log(response);
      },
      error: function(xhr, status, error) {
        console.error('Error adding product to cart:', error);
      }
    });

  });
  

  if($(".shopify-section--main-customers-account").length > 0){

    $(".order_tracking").click(function(){
      var order_id = $(this).attr("data-orderId");
      var btn_ = $(this)
      $.get(ENDPOINT,{ action: "accounts_tracking", store: 2, id: order_id })
        .done(function(data){
          var response = JSON.parse(data);

          if(response.status == 0){
            
            var popup = `<div class="no_tracking"><label>Encomenda em processo de preparação</label></div>`;
            
            $(btn_).append(popup)

            setTimeout(function(){
              $(".no_tracking").remove()
            },3000);
            
          }else{
            
            var link = response.url;
            var newTab = window.open(link, 'blank');
            newTab.focus();
          }
        }).fail(function(e){
          	console.log(e);
        })
    })
  }

  
  if(CEMAIL != "NONE" && (window.location.pathname == "/pages/gift-cards" || window.location.pathname == "/pt/pages/gift-cards" || window.location.pathname == "/es/pages/gift-cards" || window.location.pathname == "/fr/pages/gift-cards")){
    // RETIRAR EMAIL FORCADO DO MIDDLEWARE
    $.get(ENDPOINT,{ action: "accounts_giftcards", store: CHANNEL, email: CEMAIL, token: TOKEN })
    .done(function(data){
      var gift_cards_data = data = JSON.parse(data);
      console.log(gift_cards_data)
      if(data.status == 1 && gift_cards_data.data.length > 0){
        $(".page-header__text-wrapper .bubble-count").text(gift_cards_data.data.length)
        var gift_card = gift_cards_data.data

        for (let i = 0; i < gift_card.length; i++) {
          
          var html= `<tr class="account__order-table-item ">
                  <td class="gift_card_id">`+gift_card[i].id+`</td>
                  <td class="gift_card_value">`+gift_card[i].initial_value+`€</td>
                  <td class="gift_card_remaing">`+gift_card[i].balance+`€</td>
                  <td class="gift_card_expire_date">`+gift_card[i].expires_on+`</td>
                </tr>`;

          $(".gift_card_content").append(html)
        }
        
      }else{
        $(".no_gift_cards").removeClass("d-none")
      }
      
    }).fail(function(e){
    
      	console.log(e);
  
    })
  }

  if ($(".shopify-section--main-product").length > 0) {
    $(".open_size_guide").click(function () {
        if ($(window)[0].outerWidth < 768) {
            var $btn = $(".collapsible-toggle[aria-controls*='sizeguide']");
            
            if ($btn.attr("aria-expanded") !== "true") {
                $btn.trigger("click");
            }
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: $('#shopify-product-sizeguide').offset().top - 150
                }, 500);
            }, 300);
        } else {
            $(".size_guide_tab").click();
            $('html, body').animate({
                scrollTop: $('.tabs-nav__item.size_guide_tab').offset().top - 250
            }, 500);
        }
    });

    if ($(window)[0].outerWidth < 768) {
        var $descBtn = $(".collapsible-toggle[aria-controls*='description']");
        if ($descBtn.attr("aria-expanded") === "true") {
            $descBtn.trigger("click");
        }
    }
}

  if($(".product-item").length > 0){
    $(".product-item").each(function(){
      // CHAMA COUNTDOWN PARA A COLEÇÃO
      //countDown($(this))
    })
  }


  var interval = setInterval(function(){
    if($(".product #countdown").length > 0){
      // CHAMA COUNTDOWN PARA A PÁGINA DE PRODUTO
  	  //countDown($("#countdown").parent());
      clearInterval(interval);
    }
  },200)
  

  $(".btn-less").click(function() {
    document.getElementsByClassName("additional_description_content")[0].scrollIntoView();
  });
  
  $(".input__field").focusout(function() {
    if($(this).val() != ""){
      $(this).addClass("is-filled");
    }else {
      $(this).removeClass("is-filled");
    }
  });

  if($(window).width() > 768){
    $(".wash_rules_content .rule img").hover(function () {
      $(this).parent().find(".rule_alt").removeClass("d-none");
    }, function () {
      $(this).parent().find(".rule_alt").addClass("d-none");
    });
  }else{
  	$(".wash_rules_content .rule_alt ").removeClass("d-none");
    $(".wash_rules_content .rule_alt ").removeClass("position-absolute");
  }

  if($(".shopify-section--collection-banner").length > 0){
    $('.btn-more').click(function() {
      $(".additional_description_content").removeClass("overflow_text");
      $('.btn-more').addClass('d-none');
      $('.btn-less').removeClass('d-none');
    });

    $('.btn-less').click(function() {
      $(".additional_description_content").addClass("overflow_text");
      $('.btn-less').addClass('d-none');
      $('.btn-more').removeClass('d-none');
    });
  }

  $("#register-customer").change(function(){

    var prefix = $("#selectIndicative option[selected='selected']").attr("data-prefix");
    
    if( prefix == "" || prefix == undefined){
      $(".regist_btn").attr("disabled","disabled")
    }else{
      $(".regist_btn").removeAttr("disabled")
    }
  })
  

  /*$("#register-customer").submit(function(e){

    var prefix = $("#selectIndicative option[selected='selected']").attr("data-prefix");
    
    $.post( ENDPOINT,
       {
         action:"add_phone_number_on_register", 
         store: CHANNEL, 
         email: $(".emailInput")[0].value, 
         phone: $("#phone_register")[0].value, 
         country: $("#selectIndicative")[0].value,
         prefix : prefix
       }
      )
      .done(function(data) {
        console.log(data);
      })
    .fail(function(data){
        $(this).prop("disabled",false)
        alert(data)
    })
    
  });*/

  

  $(".newsletter-modal__form").submit(function(e){

    var prefix = $("#selectIndicativePopup option[selected='selected']").attr("data-prefix")
    var country_code = $("#selectIndicativePopup option[selected='selected']").attr("value")
    var phone = $("#phone_register_popup")[0].value;

    /*phone = prefix + phone
    console.log(phone)
    console.log(country_code)*/
    
    
      $.post( ENDPOINT,
         {
           action:"add_phone_number_on_register", 
           store: CHANNEL, 
           email: $(".emailInputPopup")[0].value, 
           phone: phone, 
           country: country_code,
           prefix : prefix
         }
        )
        .done(function(data) {
          console.log(data);
        })
      .fail(function(data){
          $(this).prop("disabled",false)
          alert(data)
      })
    
  });
 
});

function add_phone_number_on_register(data){
  console.log("add_phone_number_on_register")
  var parent = $(data).parent(); 
  var prefix = $(parent).find("#selectIndicative option[selected='selected']").attr("data-prefix");
  var email = $(parent).find(".emailInput")[0].value;
  var phone = $(parent).find("#phone_register")[0].value;
  var country = $(parent).find("#selectIndicative")[0].value;
  
  $.post( ENDPOINT,
     {
       action:"add_phone_number_on_register", 
       store: CHANNEL, 
       email: email, 
       phone: phone, 
       country: country,
       prefix : prefix
     }
    )
    .done(function(data) {
      console.log(data);
    })
    .fail(function(data){
        $(this).prop("disabled",false)
        alert(data)
    })

}

function checkForBanner() {
  if ($("#shopify-pc__banner").length) {
    console.log("run");
    onPopupAppear();
  } else {
    console.log("wait to run");

    // Set up a MutationObserver to detect when the banner is added
    let observer = new MutationObserver((mutations, obs) => {
      if ($("#shopify-pc__banner").length) {
        console.log("Banner detected!");
        obs.disconnect(); // Stop observing once the banner is found
        
        onPopupAppear();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
}

function onPopupAppear() {
  console.log("onPopupAppear");
     $("body").css("overflow", "hidden");
  

  var btn_accept = $("#shopify-pc__banner__btn-accept");

  $(btn_accept).click(function () {
    console.log("btn_accept click");
    $("#shopify-pc__banner__btn-manage-prefs").click();
    $("#shopify-pc__prefs__dialog #shopify-pc__prefs__header-accept").click();
     $("body").css("overflow", "auto");
  });

  $("#shopify-pc__banner__btn-decline").click(function () {
     $("body").css("overflow", "auto");
  });
}

function getSelectedOption(selectElement){
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  selectedOption.setAttribute('selected', 'selected');
}

var stockAwareCollectionState = null;
var stockAwareCollectionSyncTimer = null;
var stockAwareFilterCountTimer = null;
var stockAwareFilterCountRequests = {};
var stockAwareResultCountTimer = null;
var stockAwareResultCountRequests = {};
var stockAwareFilterCountCacheLifetime = 2 * 60 * 1000;
var stockAwareCollectionUrlChangeReadyAt = 0;

function load_more_products(){
  if (window.__stockAwareCollectionPaginationInitialized) {
    scheduleStockAwareCollectionSync();
    return;
  }

  window.__stockAwareCollectionPaginationInitialized = true;

  document.addEventListener('click', function(event) {
    var button = event.target.closest && event.target.closest('#load-more-button');
    if (!button) return;

    // Captura o clique antes do listener antigo do tema. Assim a paginação e o
    // filtro de stock usam sempre a mesma fila de produtos.
    event.preventDefault();
    event.stopImmediatePropagation();

    var state = getStockAwareCollectionState();
    if (!state || state.loading) return;

    state.loading = true;
    setLoadMoreButtonState(button, true);

    fillStockAwarePage(state, state.visibleProducts + state.pageSize)
      .catch(function(error) {
        console.error('Error loading collection products:', error);
      })
      .finally(function() {
        state.loading = false;
        updateStockAwareLoadMoreControl(state);

        var currentButton = document.getElementById('load-more-button');
        if (currentButton) setLoadMoreButtonState(currentButton, false);

        try {
          setTimeout(function() {
            if (typeof iWish !== 'undefined') iWish.checkIwishColl();
          }, 2500);
        } catch (error) {
          console.error('Error in recommendations wishlist:', error);
        }
      });
  }, true);

  var collectionRoot = document.querySelector('#facet-main');
  if (collectionRoot) {
    var observer = new MutationObserver(function(mutations) {
      if (!collectionProductDomChanged(mutations)) return;

      if (stockAwareCollectionUrlChangeReadyAt) {
        stockAwareCollectionUrlChangeReadyAt = 0;
      }

      scheduleStockAwareCollectionSync(getStockAwareCollectionUrlChangeDelay());
    });

    observer.observe(collectionRoot, {
      childList: true,
      subtree: true
    });
  }

  ['popstate', 'pageshow'].forEach(function(eventName) {
    window.addEventListener(eventName, function() {
      stockAwareCollectionUrlChangeReadyAt = Date.now() + 700;
      scheduleStockAwareCollectionSync(getStockAwareCollectionUrlChangeDelay());
    });
  });

  ['pushState', 'replaceState'].forEach(function(methodName) {
    var originalMethod = history[methodName];

    history[methodName] = function() {
      var result = originalMethod.apply(this, arguments);

      stockAwareCollectionState = null;
      stockAwareCollectionUrlChangeReadyAt = Date.now() + 700;

      scheduleStockAwareCollectionSync(
        getStockAwareCollectionUrlChangeDelay()
      );

      return result;
    };
  });

  scheduleStockAwareCollectionSync();
}

/* COLLECTION — INFINITE SCROLL */
function setupInfiniteScroll() {

  if (window.__infiniteScrollInitialized) return;
  window.__infiniteScrollInitialized = true;

  var observedButton = null;

  var observer = new IntersectionObserver(function(entries) {

    entries.forEach(function(entry) {

      if (!entry.isIntersecting) return;

      var button = document.getElementById('load-more-button');

      if (!button || button.disabled) return;

      button.click();

    });

  }, {
    root: null,
    rootMargin: '600px 0px',
    threshold: 0
  });


  function observeLoadMoreButton() {

    var button = document.getElementById('load-more-button');

    if (button === observedButton) return;

    if (observedButton) {
      observer.unobserve(observedButton);
    }

    observedButton = button;

    if (button) {
      observer.observe(button);
    }
  }


  observeLoadMoreButton();


  var mutationObserver = new MutationObserver(function() {
    observeLoadMoreButton();
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

}

/* COLLECTION — VOLTAR À POSIÇÃO EXATA APÓS VISITAR PRODUTO */
function setupCollectionBackRestore() {

  if (window.__collectionBackRestoreInitialized) return;
  window.__collectionBackRestoreInitialized = true;

  var STORAGE_KEY = 'gkCollectionReturnState';
  var collectionUrl = window.location.pathname + window.location.search;
  var restorationStarted = false;

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }


  /* Guarda o produto e a posição quando o cliente entra no produto */
  document.addEventListener('click', function(event) {

    var link = event.target.closest &&
      event.target.closest(
        '.shopify-section--main-collection .product-item a[href*="/products/"]'
      );

    if (!link) return;

    /* Não interferir com abrir em novo separador */
    if (
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0 ||
      link.target === '_blank'
    ) {
      return;
    }

    var productItem = link.closest('.product-item');
    if (!productItem) return;

    var rect = productItem.getBoundingClientRect();

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        collectionUrl: collectionUrl,
        productId: productItem.dataset.productId || '',
        viewportTop: rect.top,
        scrollY: window.scrollY,
        savedAt: Date.now()
      }));
    } catch (error) {
      console.warn('Could not save collection position.', error);
    }

  }, true);


  function getSavedState() {

    try {

      var saved = JSON.parse(
        sessionStorage.getItem(STORAGE_KEY)
      );

      if (!saved) return null;

      /* Só é válido para esta coleção */
      if (saved.collectionUrl !== collectionUrl) {
        return null;
      }

      /* Expira após 30 minutos */
      if (
        saved.savedAt &&
        Date.now() - saved.savedAt > 30 * 60 * 1000
      ) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return saved;

    } catch (error) {
      return null;
    }
  }


  function findSavedProduct(productId) {

    if (!productId) return null;

    return Array.from(
      document.querySelectorAll(
        '.shopify-section--main-collection .product-item'
      )
    ).find(function(item) {

      return String(item.dataset.productId || '') === String(productId);

    }) || null;
  }


  function restorePosition() {

    if (restorationStarted) return;

    var saved = getSavedState();
    if (!saved) return;

    restorationStarted = true;

    var attempts = 0;


    function findProductOrLoadMore() {

      var productItem = findSavedProduct(saved.productId);

      /* O produto já foi carregado */
      if (productItem) {
        finishRestore(productItem);
        return;
      }


      var button = document.getElementById('load-more-button');

      /* Já não existem mais páginas */
      if (!button) {
        finishRestore(null);
        return;
      }


      /* Está neste momento a carregar uma página */
      if (button.disabled) {
        window.setTimeout(findProductOrLoadMore, 120);
        return;
      }


      /* Carrega automaticamente a página seguinte */
      button.click();

      attempts++;

      /* Proteção contra loop infinito */
      if (attempts > 50) {
        finishRestore(null);
        return;
      }

      window.setTimeout(findProductOrLoadMore, 150);
    }


    function finishRestore(productItem) {

      /*
       * Dá tempo ao banner grid e à grelha para terminarem
       * de ocupar as posições definitivas.
       */
      window.setTimeout(function() {

        window.requestAnimationFrame(function() {

          window.requestAnimationFrame(function() {

            var targetScroll = saved.scrollY || 0;

            if (
              productItem &&
              typeof saved.viewportTop === 'number'
            ) {

              targetScroll =
                window.scrollY +
                productItem.getBoundingClientRect().top -
                saved.viewportTop;
            }

            window.scrollTo({
              top: Math.max(0, targetScroll),
              left: 0,
              behavior: 'auto'
            });


            /*
             * Segunda confirmação depois de imagens/banner
             * terminarem de estabilizar.
             */
            window.setTimeout(function() {

              if (productItem) {

                var correctedScroll =
                  window.scrollY +
                  productItem.getBoundingClientRect().top -
                  saved.viewportTop;

                window.scrollTo({
                  top: Math.max(0, correctedScroll),
                  left: 0,
                  behavior: 'auto'
                });
              }

              try {
                sessionStorage.removeItem(STORAGE_KEY);
              } catch (error) {}

            }, 250);

          });

        });

      }, 150);
    }


    findProductOrLoadMore();
  }


  /* Regresso através do botão Back */
  window.addEventListener('pageshow', function() {
    window.setTimeout(restorePosition, 0);
  });


  /* Regresso em browsers que reconstruam totalmente a página */
  window.setTimeout(restorePosition, 0);

}

function getStockAwareCollectionUrlChangeDelay(){
  var delay = stockAwareCollectionUrlChangeReadyAt - Date.now();
  return delay > 0 ? delay : undefined;
}

function collectionProductDomChanged(mutations){
  return Array.from(mutations || []).some(function(mutation) {
    return Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes)).some(function(node) {
      if (!node || node.nodeType !== 1) return false;
      if (isCollectionProductItem(node)) return true;
      return node.querySelector && !!node.querySelector('.product-list__inner .product-item, product-list .product-item');
    });
  });
}

function scheduleStockAwareCollectionSync(delay){
  window.clearTimeout(stockAwareCollectionSyncTimer);
  stockAwareCollectionSyncTimer = window.setTimeout(function() {
    var state = getStockAwareCollectionState();
    if (state) scheduleVariantStockResultCountRefresh();
    if (!state || state.loading || !state.hasVariantFilters) return;

    state.loading = true;
    fillStockAwarePage(state, state.pageSize)
      .catch(function(error) {
        console.error('Error filtering collection variants by availability:', error);
      })
      .finally(function() {
        state.loading = false;
        updateStockAwareLoadMoreControl(state);
      });
  }, typeof delay === 'number' ? delay : 50);
}

function getStockAwareCollectionState(){
  var productList = document.querySelector('#facet-main .product-list__inner');
  if (!productList) return null;

  var signature = window.location.pathname + window.location.search;
  var hasUnmanagedProducts = getDirectProductItems(productList).some(function(item) {
    return item.dataset.stockAvailabilityManaged !== 'true';
  });

  if (!stockAwareCollectionState
      || stockAwareCollectionState.productList !== productList
      || stockAwareCollectionState.signature !== signature
      || hasUnmanagedProducts) {
    stockAwareCollectionState = createStockAwareCollectionState(productList, signature);
  }

  return stockAwareCollectionState;
}

function createStockAwareCollectionState(productList, signature){
  var productListElement = productList.closest('product-list');
  var initialProducts = getDirectProductItems(productList);
  var state = {
    productList: productList,
    productListElement: productListElement,
    signature: signature,
    variantFilters: getActiveVariantFilters(),
    hasVariantFilters: false,
    pageSize: parseInt(productListElement && productListElement.dataset.productsPerPage, 10) || initialProducts.length || 1,
    visibleProducts: 0,
    buffer: [],
    productIds: new Set(),
    fetchedUrls: new Set(),
    nextUrl: getNextCollectionPageUrl(productList),
    loading: false
  };

  state.hasVariantFilters = Object.keys(state.variantFilters).length > 0;

  initialProducts.forEach(function(item) {
    item.dataset.stockAvailabilityManaged = 'true';

    if (rememberProductId(state, item) && productMatchesAvailableVariant(item, state.variantFilters)) {
      state.visibleProducts++;
      item.classList.add('loaded-item');
    } else {
      item.remove();
    }
  });

  productList.dispatchEvent(new CustomEvent('collection:products:changed', {
    bubbles: true,
    detail: { visibleProducts: state.visibleProducts }
  }));

  updateStockAwareEmptyState(state);
  return state;
}

function getDirectProductItems(productList){
  return Array.from(productList.children).filter(function(item) {
    return isCollectionProductItem(item);
  });
}

function isCollectionProductItem(item){
  return item
    && item.nodeType === 1
    && item.classList
    && item.classList.contains('product-item')
    && !item.classList.contains('banner-section')
    && !item.hasAttribute('data-banner-section');
}

function getActiveVariantFilters(){
  var filters = {};
  var prefix = 'filter.v.option.';
  var searchParams = new URLSearchParams(window.location.search);

  searchParams.forEach(function(value, name) {
    if (name.indexOf(prefix) !== 0) return;

    var optionName = normaliseVariantOptionName(name.slice(prefix.length));
    var optionValue = normaliseVariantValue(value);
    if (!optionName || !optionValue) return;

    if (!filters[optionName]) filters[optionName] = [];
    if (filters[optionName].indexOf(optionValue) === -1) filters[optionName].push(optionValue);
  });

  document.querySelectorAll('input[name^="filter.v.option."]:checked').forEach(function(input) {
    var optionName = normaliseVariantOptionName(input.name.slice(prefix.length));
    var optionValue = normaliseVariantValue(input.value);
    if (!optionName || !optionValue) return;

    if (!filters[optionName]) filters[optionName] = [];
    if (filters[optionName].indexOf(optionValue) === -1) filters[optionName].push(optionValue);
  });

  return filters;
}

function normaliseVariantValue(value){
  return String(value || '')
    .trim()
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function normaliseVariantOptionName(value){
  var optionName = normaliseVariantValue(value);

  if ([
    'size',
    'sizes',
    'tamanho',
    'tamanhos',
    'talla',
    'tallas',
    'taille',
    'tailles',
    'grosse',
    'grossen',
    'groesse',
    'groessen',
    'grandeur',
    'grandeurs'
  ].indexOf(optionName) !== -1) {
    return 'size';
  }

  if ([
    'color',
    'colors',
    'colour',
    'colours',
    'cor',
    'cores',
    'couleur',
    'couleurs',
    'farbe',
    'farben',
    'colore',
    'colori'
  ].indexOf(optionName) !== -1) {
    return 'color';
  }

  return optionName;
}

function productMatchesAvailableVariant(item, activeFilters){
  if (Object.keys(activeFilters).length === 0) return true;

  var dataElement = item.querySelector('.product-item__variant-stock');
  if (!dataElement) return true; // Não esconder um produto se os dados ainda não chegaram ao HTML.

  try {
    var productData = JSON.parse(dataElement.textContent);
    var optionIndexes = {};

    productData.options.forEach(function(optionName, index) {
      optionIndexes[normaliseVariantOptionName(optionName)] = index;
    });

    return productData.variants.some(function(variant) {
      if (!variant.available) return false;

      return Object.keys(activeFilters).every(function(optionName) {
        var optionIndex = optionIndexes[optionName];
        if (typeof optionIndex === 'undefined') return false;

        return activeFilters[optionName].indexOf(normaliseVariantValue(variant.options[optionIndex])) !== -1;
      });
    });
  } catch (error) {
    console.warn('Could not read product variant availability data.', error);
    return true;
  }
}

function rememberProductId(state, item){
  var productId = item.dataset.productId;
  if (!productId) return true;
  if (state.productIds.has(productId)) return false;

  state.productIds.add(productId);
  return true;
}

function getNextCollectionPageUrl(productList){
  var button = document.querySelector('#facet-main #load-more-button');
  if (button && button.getAttribute('data-url')) return button.getAttribute('data-url');

  return getFallbackNextCollectionPageUrl(window.location.href, productList);
}

function getFallbackNextCollectionPageUrl(currentUrl, productList){
  var productListElement = productList && productList.closest('product-list');
  if (!productListElement) return null;

  var currentPage = parseInt(productListElement.dataset.currentPage, 10);
  var totalPages = parseInt(productListElement.dataset.totalPages, 10);
  if (!currentPage || !totalPages || currentPage >= totalPages) return null;

  // Algumas respostas AJAX não devolvem o botão. Os dados do paginate são a
  // fonte de verdade: constrói a página seguinte preservando todos os filtros.
  var nextUrl = new URL(currentUrl, window.location.origin);
  nextUrl.searchParams.set('page', currentPage + 1);
  return nextUrl.pathname + nextUrl.search + nextUrl.hash;
}

async function fillStockAwarePage(state, targetProductCount){
  appendBufferedProducts(state, targetProductCount);

  while (state.visibleProducts < targetProductCount && state.nextUrl) {
    await fetchNextCollectionSourcePage(state);
    appendBufferedProducts(state, targetProductCount);
  }

  updateStockAwareEmptyState(state);
}

function appendBufferedProducts(state, targetProductCount){
  if (!state.buffer.length || state.visibleProducts >= targetProductCount) return;

  var fragment = document.createDocumentFragment();
  while (state.buffer.length && state.visibleProducts < targetProductCount) {
    fragment.appendChild(state.buffer.shift());
    state.visibleProducts++;
  }

  state.productList.appendChild(fragment);
  state.productList.dispatchEvent(new CustomEvent('collection:products:appended', {
    bubbles: true,
    detail: { visibleProducts: state.visibleProducts }
  }));
}

async function fetchNextCollectionSourcePage(state){
  var url = state.nextUrl;
  if (!url || state.fetchedUrls.has(url)) {
    state.nextUrl = null;
    return;
  }

  state.fetchedUrls.add(url);
  var response = await fetch(url, { credentials: 'same-origin' });
  if (!response.ok) throw new Error('Unable to load collection page: ' + response.status);

  var documentResponse = new DOMParser().parseFromString(await response.text(), 'text/html');
  var sourceList = documentResponse.querySelector('#facet-main .product-list__inner') || documentResponse.querySelector('.product-list__inner');

  if (!sourceList) throw new Error('The next collection page does not contain a product list.');

  var nextButton = documentResponse.querySelector('#load-more-button');
  state.nextUrl = nextButton && nextButton.getAttribute('data-url')
    ? nextButton.getAttribute('data-url')
    : getFallbackNextCollectionPageUrl(url, sourceList);

  getDirectProductItems(sourceList).forEach(function(item) {
    item.dataset.stockAvailabilityManaged = 'true';
    if (rememberProductId(state, item) && productMatchesAvailableVariant(item, state.variantFilters)) {
      item.classList.add('loaded-item');
      state.buffer.push(item);
    }
  });
}

function updateStockAwareLoadMoreControl(state){
  var container = document.getElementById('load-more-button-container');
  var button = document.getElementById('load-more-button');
  var hasMoreProducts = state.nextUrl || state.buffer.length;

  if (button && state.nextUrl) button.setAttribute('data-url', state.nextUrl);

  if (!hasMoreProducts && container) {
    container.remove();
    var noMoreProductsMessage = document.getElementById('no-more-products-message');
    if (noMoreProductsMessage) noMoreProductsMessage.style.display = 'block';
  }
}

function updateStockAwareEmptyState(state){
  var emptyStateId = state.productListElement && state.productListElement.dataset.stockEmptyStateId;
  var emptyState = emptyStateId && document.getElementById(emptyStateId);
  if (!emptyState) return;

  var isEmpty = state.hasVariantFilters && state.visibleProducts === 0 && !state.nextUrl && !state.buffer.length;
  emptyState.hidden = !isEmpty;
  state.productListElement.hidden = isEmpty;
}

function setLoadMoreButtonState(button, isLoading){
  if (!button) return;

  if (isLoading) {
    button.dataset.originalHtml = button.innerHTML;
    button.classList.add('btn--loading');
    button.innerHTML = '<span class="btn-text">' + button.dataset.originalHtml + '</span> <span class="spinner"></span>';
    button.disabled = true;
    return;
  }

  if (button.dataset.originalHtml) button.innerHTML = button.dataset.originalHtml;
  button.classList.remove('btn--loading');
  button.disabled = false;
}

function scheduleVariantStockFilterCountRefresh(){
  window.clearTimeout(stockAwareFilterCountTimer);
  stockAwareFilterCountTimer = window.setTimeout(function() {
    // Deixa a abertura do filtro acontecer primeiro e calcula em segundo plano.
    var refresh = function() { refreshVariantStockFilterCounts(); };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(refresh, { timeout: 750 });
    } else {
      refresh();
    }
  }, 150);
}

function refreshVariantStockFilterCounts(){
  var counters = Array.from(document.querySelectorAll('[data-variant-stock-count]'));
  if (!counters.length) return;

  var groups = {};
  counters.forEach(function(counter) {
    var parameterName = counter.dataset.filterParamName;
    var value = normaliseVariantValue(counter.dataset.filterValue);
    if (!parameterName || !value) return;

    if (!groups[parameterName]) groups[parameterName] = { counters: [], values: {} };
    groups[parameterName].counters.push(counter);
    groups[parameterName].values[value] = true;
  });

  Object.keys(groups).forEach(function(parameterName) {
    var group = groups[parameterName];
    var signature = window.location.pathname + window.location.search + '|' + parameterName;
    var cacheKey = getVariantStockFilterCountCacheKey(parameterName);
    var alreadyUpdated = group.counters.every(function(counter) {
      return counter.dataset.variantStockCountSignature === signature;
    });

    if (alreadyUpdated) return;

    setVariantStockFilterGroupLoading(group.counters, true);

    var cachedCounts = getCachedVariantStockFilterCounts(cacheKey, group.values);
    if (cachedCounts) {
      applyVariantStockFilterCounts(group.counters, cachedCounts, signature);
      return;
    }

    if (stockAwareFilterCountRequests[cacheKey]) {
      // O filtro pode ter sido substituído enquanto o pedido anterior corria.
      // Quando terminar, aplica o resultado à versão atual do filtro.
      stockAwareFilterCountRequests[cacheKey].finally(function() {
        scheduleVariantStockFilterCountRefresh();
      });
      return;
    }

    stockAwareFilterCountRequests[cacheKey] = getVariantStockCounts(parameterName, group.values)
      .then(function(result) {
        if (!result.hasVariantData) return;

        setCachedVariantStockFilterCounts(cacheKey, result.counts);
        applyVariantStockFilterCounts(group.counters, result.counts, signature);
      })
      .catch(function(error) {
        // Mantém a contagem do Shopify caso não seja possível calcular o stock.
        console.error('Error calculating available variant filter counts:', error);
      })
      .finally(function() {
        delete stockAwareFilterCountRequests[cacheKey];
      });
  });
}

function applyVariantStockFilterCounts(counters, counts, signature){
  counters.forEach(function(counter) {
    var value = normaliseVariantValue(counter.dataset.filterValue);
    var count = counts[value] || 0;
    counter.textContent = count;
    counter.dataset.variantStockCountSignature = signature;
    updateVariantStockFilterValueState(counter, count);
  });

  setVariantStockFilterGroupLoading(counters, false);
}

function setVariantStockFilterGroupLoading(counters, isLoading){
  var filterLists = new Set();
  counters.forEach(function(counter) {
    var filterList = counter.closest('[data-variant-stock-counts]');
    if (filterList) filterLists.add(filterList);
  });

  filterLists.forEach(function(filterList) {
    filterList.classList.toggle('is-loading', isLoading);
    filterList.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  });
}

function getVariantStockFilterCountCacheKey(parameterName){
  var url = new URL(window.location.href);
  url.searchParams.delete(parameterName);
  url.searchParams.delete('page');
  return 'variant-stock-counts:' + url.pathname + url.search + '|' + parameterName;
}

function getCachedVariantStockFilterCounts(cacheKey, values){
  try {
    var cached = JSON.parse(window.sessionStorage.getItem(cacheKey));
    if (!cached || Date.now() - cached.savedAt > stockAwareFilterCountCacheLifetime) return null;

    var hasEveryValue = Object.keys(values).every(function(value) {
      return Object.prototype.hasOwnProperty.call(cached.counts, value);
    });
    return hasEveryValue ? cached.counts : null;
  } catch (error) {
    return null;
  }
}

function setCachedVariantStockFilterCounts(cacheKey, counts){
  try {
    window.sessionStorage.setItem(cacheKey, JSON.stringify({ savedAt: Date.now(), counts: counts }));
  } catch (error) {
    // A loja continua a funcionar se o navegador bloquear o armazenamento local.
  }
}

function updateVariantStockFilterValueState(counter, count){
  var swatch = counter.closest('.block-swatch');
  var input = swatch && swatch.querySelector('input');
  if (!swatch || !input) return;

  // Um tamanho sem stock deixa de ser apresentado. Se já estiver escolhido,
  // mantém-se visível para a pessoa o conseguir remover.
  var shouldHide = count === 0 && !input.checked;
  swatch.hidden = shouldHide;
  swatch.classList.toggle('is-disabled', count === 0);
  input.disabled = count === 0 && !input.checked;
}

async function getVariantStockCounts(parameterName, values){
  var baseUrl = new URL(window.location.href);
  baseUrl.searchParams.delete(parameterName);
  baseUrl.searchParams.delete('page');

  var firstDocument = await fetchCollectionCountDocument(baseUrl);
  var firstProductList = firstDocument.querySelector('#facet-main .product-list__inner') || firstDocument.querySelector('.product-list__inner');
  if (!firstProductList) throw new Error('Collection product list not found while calculating filter counts.');

  var counts = {};
  Object.keys(values).forEach(function(value) { counts[value] = 0; });

  var seenProductIds = new Set();
  var hasVariantData = countAvailableVariantsInProductList(firstProductList, parameterName, values, counts, seenProductIds);
  var productListElement = firstProductList.closest('product-list');
  var totalPages = parseInt(
    productListElement && (productListElement.dataset.stockCountTotalPages || productListElement.dataset.totalPages),
    10
  ) || 1;
  var pageUrls = [];

  for (var page = 2; page <= totalPages; page++) {
    var pageUrl = new URL(baseUrl);
    pageUrl.searchParams.set('page', page);
    pageUrls.push(pageUrl);
  }

  var extraPagesHaveVariantData = await fetchCollectionCountPages(pageUrls, function(documentResponse) {
    var productList = documentResponse.querySelector('#facet-main .product-list__inner') || documentResponse.querySelector('.product-list__inner');
    if (!productList) return false;

    return countAvailableVariantsInProductList(productList, parameterName, values, counts, seenProductIds);
  });

  return {
    counts: counts,
    hasVariantData: hasVariantData || extraPagesHaveVariantData
  };
}

async function fetchCollectionCountDocument(url){
  var response = await fetch(url.toString(), { credentials: 'same-origin' });
  if (!response.ok) throw new Error('Unable to load collection page: ' + response.status);

  return new DOMParser().parseFromString(await response.text(), 'text/html');
}

async function fetchCollectionCountPages(urls, callback){
  var nextIndex = 0;
  var hasVariantData = false;
  var workerCount = Math.min(6, urls.length);
  var workers = [];

  for (var worker = 0; worker < workerCount; worker++) {
    workers.push((async function() {
      while (nextIndex < urls.length) {
        var url = urls[nextIndex++];
        var documentResponse = await fetchCollectionCountDocument(url);
        if (callback(documentResponse)) hasVariantData = true;
      }
    })());
  }

  await Promise.all(workers);
  return hasVariantData;
}

function countAvailableVariantsInProductList(productList, parameterName, values, counts, seenProductIds){
  var optionName = normaliseVariantOptionName(parameterName.replace('filter.v.option.', ''));
  var otherActiveFilters = getActiveVariantFilters();
  delete otherActiveFilters[optionName];
  var hasVariantData = false;

  getDirectProductItems(productList).forEach(function(item) {
    var productId = item.dataset.productId;
    if (productId && seenProductIds.has(productId)) return;
    if (productId) seenProductIds.add(productId);

    var dataElement = item.querySelector('.product-item__variant-stock');
    if (!dataElement) return;

    var productData;
    try {
      productData = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    hasVariantData = true;
    var optionIndexes = {};
    productData.options.forEach(function(name, index) {
      optionIndexes[normaliseVariantOptionName(name)] = index;
    });

    var targetOptionIndex = optionIndexes[optionName];
    if (typeof targetOptionIndex === 'undefined') return;

    var countedValuesForProduct = {};
    productData.variants.forEach(function(variant) {
      if (!variant.available || !variantMatchesActiveFilters(variant, optionIndexes, otherActiveFilters)) return;

      var value = normaliseVariantValue(variant.options[targetOptionIndex]);
      if (values[value]) countedValuesForProduct[value] = true;
    });

    Object.keys(countedValuesForProduct).forEach(function(value) {
      counts[value]++;
    });
  });

  return hasVariantData;
}

function variantMatchesActiveFilters(variant, optionIndexes, activeFilters){
  return Object.keys(activeFilters).every(function(optionName) {
    var optionIndex = optionIndexes[optionName];
    if (typeof optionIndex === 'undefined') return false;

    return activeFilters[optionName].indexOf(normaliseVariantValue(variant.options[optionIndex])) !== -1;
  });
}

function scheduleVariantStockResultCountRefresh(){
  window.clearTimeout(stockAwareResultCountTimer);
  stockAwareResultCountTimer = window.setTimeout(function() {
    var refresh = function() { refreshVariantStockResultCount(); };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(refresh, { timeout: 300 });
    } else {
      refresh();
    }
  }, 50);
}

function refreshVariantStockResultCount(){
  var counters = Array.from(document.querySelectorAll('[data-variant-stock-result-count]'));
  var activeFilters = getActiveVariantFilters();
  if (!counters.length || Object.keys(activeFilters).length === 0) return;

  var signature = window.location.pathname + window.location.search;
  var cacheKey = getVariantStockResultCountCacheKey();
  var alreadyUpdated = counters.every(function(counter) {
    return counter.dataset.variantStockResultCountSignature === signature;
  });
  if (alreadyUpdated) return;

  var cachedCount = getCachedVariantStockResultCount(cacheKey);
  if (cachedCount !== null) {
    applyVariantStockResultCount(counters, cachedCount, signature);
    return;
  }

  setVariantStockResultCountLoading(counters, true);
  if (stockAwareResultCountRequests[cacheKey]) {
    stockAwareResultCountRequests[cacheKey].finally(function() {
      scheduleVariantStockResultCountRefresh();
    });
    return;
  }

  stockAwareResultCountRequests[cacheKey] = getAvailableVariantProductResultCount(activeFilters)
    .then(function(result) {
      if (!result.hasVariantData) return;

      setCachedVariantStockResultCount(cacheKey, result.count);
      applyVariantStockResultCount(counters, result.count, signature);
    })
    .catch(function(error) {
      console.error('Error calculating the available product result count:', error);
    })
    .finally(function() {
      delete stockAwareResultCountRequests[cacheKey];
    });
}

function setVariantStockResultCountLoading(counters, isLoading){
  counters.forEach(function(counter) {
    counter.classList.toggle('is-loading', isLoading);
    if (isLoading) counter.innerHTML = getVariantStockLoadingIcon();
  });
}

function getVariantStockLoadingIcon(){
  return '<svg width="18" height="18" viewBox="0 0 50 50" aria-label="A verificar stock" role="img"><circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="4" stroke-dasharray="31.4 31.4"><animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite"></animateTransform></circle></svg>';
}

function applyVariantStockResultCount(counters, count, signature){
  counters.forEach(function(counter) {
    var template = count === 1 ? counter.dataset.countTemplateSingular : counter.dataset.countTemplatePlural;
    counter.textContent = template ? template.replace('__count__', count) : count + ' products';
    counter.dataset.variantStockResultCountSignature = signature;
    counter.classList.remove('is-loading');
  });
}

function getVariantStockResultCountCacheKey(){
  var url = new URL(window.location.href);
  url.searchParams.delete('page');
  return 'variant-stock-result-count:' + url.pathname + url.search;
}

function getCachedVariantStockResultCount(cacheKey){
  try {
    var cached = JSON.parse(window.sessionStorage.getItem(cacheKey));
    if (!cached || Date.now() - cached.savedAt > stockAwareFilterCountCacheLifetime) return null;
    return typeof cached.count === 'number' ? cached.count : null;
  } catch (error) {
    return null;
  }
}

function setCachedVariantStockResultCount(cacheKey, count){
  try {
    window.sessionStorage.setItem(cacheKey, JSON.stringify({ savedAt: Date.now(), count: count }));
  } catch (error) {
    // A contagem continua a funcionar se o navegador bloquear o armazenamento local.
  }
}

async function getAvailableVariantProductResultCount(activeFilters){
  var baseUrl = new URL(window.location.href);
  baseUrl.searchParams.delete('page');

  var firstDocument = await fetchCollectionCountDocument(baseUrl);
  var firstProductList = firstDocument.querySelector('#facet-main .product-list__inner') || firstDocument.querySelector('.product-list__inner');
  if (!firstProductList) throw new Error('Collection product list not found while calculating the result count.');

  var productListElement = firstProductList.closest('product-list');
  var totalPages = parseInt(
    productListElement && (productListElement.dataset.stockCountTotalPages || productListElement.dataset.totalPages),
    10
  ) || 1;
  var pageUrls = [];
  for (var page = 2; page <= totalPages; page++) {
    var pageUrl = new URL(baseUrl);
    pageUrl.searchParams.set('page', page);
    pageUrls.push(pageUrl);
  }

  var seenProductIds = new Set();
  var result = { count: 0, hasVariantData: false };
  countAvailableProductsInProductList(firstProductList, activeFilters, result, seenProductIds);

  await fetchCollectionCountPages(pageUrls, function(documentResponse) {
    var productList = documentResponse.querySelector('#facet-main .product-list__inner') || documentResponse.querySelector('.product-list__inner');
    if (!productList) return false;

    countAvailableProductsInProductList(productList, activeFilters, result, seenProductIds);
    return result.hasVariantData;
  });

  return result;
}

function countAvailableProductsInProductList(productList, activeFilters, result, seenProductIds){
  getDirectProductItems(productList).forEach(function(item) {
    var productId = item.dataset.productId;
    if (productId && seenProductIds.has(productId)) return;
    if (productId) seenProductIds.add(productId);

    var dataElement = item.querySelector('.product-item__variant-stock');
    if (!dataElement) return;

    var productData;
    try {
      productData = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    result.hasVariantData = true;
    var optionIndexes = {};
    productData.options.forEach(function(name, index) {
      optionIndexes[normaliseVariantOptionName(name)] = index;
    });

    var hasAvailableMatchingVariant = productData.variants.some(function(variant) {
      return variant.available && variantMatchesActiveFilters(variant, optionIndexes, activeFilters);
    });

    if (hasAvailableMatchingVariant) result.count++;
  });
}

async function removeWishlist(data){
  let prod_id = $(data).attr("data-product");
  let var_id = $(data).attr("data-variant")
  const url = 'https://api.myshopapps.com/wishlist/V2/removeWishlist/';
  const options = {
    method: 'POST',
    headers: {
      xtoken: 'IWISH_API_020787da489711f1b45ce6a496eb750e',
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json'
    },
    body: new URLSearchParams({customer_id: CID, product_id: prod_id, variant_id: var_id})
  };
  
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    window.location.reload()
  } catch (error) {
    console.error(error);
  }
}

async function wishlistCount() {
  
  const url = 'https://api.myshopapps.com/wishlist/V2/count/'+CID;
  
  const options = {
    method: 'POST',
    headers: {
      xtoken: 'IWISH_API_020787da489711f1b45ce6a496eb750e',
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json'
    },
    body: new URLSearchParams({})
  };
  
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    
    if(data.result > 0){
      $(".wishlist_count")[0].innerText = data.result  
      $(".wishlist_count")[1].innerText = data.result  
      $(".wishlist_count").removeClass("d-none")
    }
    
  } catch (error) {
    console.error(error);
  }
}

// Seleciona a primeira variante realmente disponível quando o produto abre.
// Não depende das classes visuais usadas para riscar uma opção sem stock.
function selectFirstAvailableProductOption(){

  document.querySelectorAll('quick-buy-drawer, quick-buy-popover').forEach(function(quickView){

    quickView.querySelectorAll('.block-swatch-list.variants__').forEach(function(optionList){

      var selectedInput = optionList.querySelector('input:checked');

      if (!selectedInput || !isUnavailableSwatch(selectedInput)) {
        return;
      }

      var firstAvailableSwatch = Array.from(
        optionList.querySelectorAll('.block-swatch')
      ).find(function(swatch){

        var input = swatch.querySelector('input');

        return input &&
          !swatch.classList.contains('is-disabled') &&
          !input.disabled;
      });

      var firstAvailableInput =
        firstAvailableSwatch &&
        firstAvailableSwatch.querySelector('input');

      if (firstAvailableInput) {
        firstAvailableInput.click();
      }

    });

  });

}
function selectFirstAvailableSwatch(){
  var hasSelectedNewOption = false;

  // "variants__" existe apenas nos seletores de variantes do produto; assim
  // nunca interfere com os filtros da coleção.
  document.querySelectorAll('.block-swatch-list.variants__').forEach(function(optionList) {
    var selectedInput = optionList.querySelector('input:checked');
    if (!selectedInput || !isUnavailableSwatch(selectedInput)) return;

    var firstAvailableSwatch = Array.from(optionList.querySelectorAll('.block-swatch')).find(function(swatch) {
      var input = swatch.querySelector('input');
      return input && !swatch.classList.contains('is-disabled') && !input.disabled;
    });
    var firstAvailableInput = firstAvailableSwatch && firstAvailableSwatch.querySelector('input');
    if (!firstAvailableInput) return;

    // O clique no próprio campo atualiza o formulário e os elementos do tema.
    firstAvailableInput.click();
    if (!firstAvailableInput.checked) {
      firstAvailableInput.checked = true;
      firstAvailableInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    hasSelectedNewOption = true;
  });

  return hasSelectedNewOption;
}

function getVariantsFromProductPicker(picker){
  var containers = [picker, picker.closest('quick-buy-drawer'), picker.closest('.shopify-section--main-product')].filter(Boolean);

  for (var index = 0; index < containers.length; index++) {
    var scripts = containers[index].querySelectorAll('script[type="application/json"]');
    for (var scriptIndex = 0; scriptIndex < scripts.length; scriptIndex++) {
      try {
        var variants = findVariantArray(JSON.parse(scripts[scriptIndex].textContent));
        if (variants.length) return variants;
      } catch (error) {
        // Ignora dados JSON que não correspondem às variantes do produto.
      }
    }
  }

  return [];
}

function findVariantArray(data, depth){
  if (Array.isArray(data) && data.some(isProductVariant)) return data;
  if (!data || typeof data !== 'object' || (depth || 0) >= 3) return [];

  if (Array.isArray(data.variants) && data.variants.some(isProductVariant)) return data.variants;

  var keys = Object.keys(data);
  for (var index = 0; index < keys.length; index++) {
    var value = data[keys[index]];
    if (Array.isArray(value) && value.some(isProductVariant)) return value;
    if (value && typeof value === 'object') {
      var nestedVariants = findVariantArray(value, (depth || 0) + 1);
      if (nestedVariants.length) return nestedVariants;
    }
  }

  return [];
}

function isProductVariant(value){
  return value && typeof value === 'object' && value.id !== undefined && value.available !== undefined;
}

function getCurrentProductVariantId(picker){
  var formId = picker.getAttribute('form-id');
  var form = formId && document.getElementById(formId);
  form = form || picker.closest('form') || picker.querySelector('form');
  var variantInput = form && form.querySelector('[name="id"]');
  return variantInput && variantInput.value;
}

function isUnavailableSwatch(input){
  var swatch = input.closest('.block-swatch');
  var label = swatch && swatch.querySelector('label');
  return input.disabled
    || (swatch && swatch.classList.contains('is-disabled'))
    || (label && (label.classList.contains('is-disabled') || label.getAttribute('aria-disabled') === 'true'));
}

function observeFirstAvailableProductOption(){
  if (window.__firstAvailableProductOptionObserver) return;
  window.__firstAvailableProductOptionObserver = true;

  var timer;
  var scheduleSelection = function(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(function() {
      selectFirstAvailableProductOption();
      // O painel rápido acaba de carregar em fases; confirma de novo depois
      // de o tema terminar de atualizar as opções.
      window.setTimeout(selectFirstAvailableProductOption, 150);
      window.setTimeout(selectFirstAvailableProductOption, 400);
    }, delay || 100);
  };

  var observer = new MutationObserver(function(mutations) {
    var hasNewProductPicker = mutations.some(function(mutation) {
      return Array.from(mutation.addedNodes).some(function(node) {
        return node.nodeType === 1
          && (node.matches('product-variants, quick-buy-drawer, .drawer--quick-buy') || node.querySelector('product-variants, quick-buy-drawer, .drawer--quick-buy'));
      });
    });
    if (hasNewProductPicker) scheduleSelection(100);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('product-variants').then(function() {
      scheduleSelection(0);
    });
  }
  scheduleSelection(250);
}

// FUNCTION TO SHOW NOTIFY OR ADD TO CART BTN
function changeAddCartBtn(){
  if (!document.getElementById('stable-add-to-cart-loading')) $('<style id="stable-add-to-cart-loading">#AddToCart[aria-busy="true"] { display: block !important; }</style>').appendTo('head');
  function syncBackInStockButtons(){
    $('form[is="product-form"]').each(function(){
      var form = $(this);
      var addToCart = form.find('#AddToCart, #StickyAddToCart, [data-product-add-to-cart-button]').first();
      var notifyButton = form.find('#BIS_trigger').first();
      var variantInput = form.find('input[name="id"]').first();
      var wishlistButton = form.find('.wishlist-trigger--proxy').first();
      if (!addToCart.length || !notifyButton.length) return;

      if (variantInput.length) notifyButton.attr('data-variant-id', variantInput.val());

var isSoldOut = addToCart.prop('disabled') && addToCart.attr('aria-busy') !== 'true';
      var paymentContainer = notifyButton.parent();
      var wishlistRow = wishlistButton.parent();

      addToCart.toggleClass('d-none', isSoldOut).css('display', isSoldOut ? 'none' : 'block');
      notifyButton.toggleClass('d-none', !isSoldOut);

      if (isSoldOut && wishlistButton.length) {
        paymentContainer.css({ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 44px', columnGap: '12px', alignItems: 'center' });
        wishlistRow.css('display', 'contents');
        notifyButton.css({ gridColumn: '1', gridRow: '1', width: '100%' });
        wishlistButton.css({ gridColumn: '2', gridRow: '1' });
      } else {
        paymentContainer.css({ display: '', gridTemplateColumns: '', columnGap: '', alignItems: '' });
        wishlistRow.css('display', 'flex');
        notifyButton.css({ gridColumn: '', gridRow: '', width: '' });
        wishlistButton.css({ gridColumn: '', gridRow: '' });
      }
    });
  }

  $(document)
    .off('click.bisTheme', '.block-swatch__item')
    .on('click.bisTheme', '.block-swatch__item', function(){
      window.setTimeout(syncBackInStockButtons, 0);
      window.setTimeout(syncBackInStockButtons, 250);
      window.setTimeout(syncBackInStockButtons, 1000);
      window.setTimeout(syncBackInStockButtons, 2000);
    });

  if (!window.__bisThemeVariantListener) {
    window.__bisThemeVariantListener = true;
    document.addEventListener('variant:changed', function(){
      window.setTimeout(syncBackInStockButtons, 0);
      window.setTimeout(syncBackInStockButtons, 250);
      window.setTimeout(syncBackInStockButtons, 1000);
      window.setTimeout(syncBackInStockButtons, 2000);
    });
  }

  syncBackInStockButtons();
  window.setTimeout(syncBackInStockButtons, 500);
  window.setTimeout(syncBackInStockButtons, 2000);
  window.setTimeout(syncBackInStockButtons, 5000);
}
// Countdown
function countDown(prod){
  //console.log("== COUNTDOWN ==")
  if(document.getElementById("countdown") != null){
     var endDate = document.getElementById("countdown").getAttribute("data-date")
    var countDownDate = new Date(endDate).getTime();
  
    const currentTime = new Date().getTime();
    const differenceInMilliseconds = countDownDate - currentTime;
  
    const showCountdown = 48 * 60 * 60 * 1000; // 48 hours
  
    if (differenceInMilliseconds < showCountdown && differenceInMilliseconds > 0) {
      console.log("Time difference is less than 48 hours");
      $(prod).find("#countdown").removeClass("d-none")
      //document.getElementById("countdown").classList.remove("d-none");
      document.getElementById("countDownTitle").classList.remove("d-none");
      
      var x = setInterval(function() {
  
        var now = new Date().getTime();
          
        var distance = countDownDate - now;
          
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
        var countDownDays = `<span>`+days+`</span><label>Day</label>`;
        var countDownHours = `<span>`+hours+`</span><label>Hour</label>`;
        var countDownMinutes = `<span>`+minutes+`</span><label>Minute</label>`;
        var countDownSeconds = `<span>`+seconds+`</span><label>Second</label>`;

        
        $(prod).find("#countdown-days")[0].innerHTML = countDownDays;
        $(prod).find("#countdown-hours")[0].innerHTML = countDownHours;
        $(prod).find("#countdown-minutes")[0].innerHTML = countDownMinutes;
        $(prod).find("#countdown-seconds")[0].innerHTML = countDownSeconds;
        /*document.getElementById("countdown-days").innerHTML = countDownDays;
        document.getElementById("countdown-hours").innerHTML = countDownHours;
        document.getElementById("countdown-minutes").innerHTML = countDownMinutes;
        document.getElementById("countdown-seconds").innerHTML = countDownSeconds;*/
          
        if (distance < 0) {
          clearInterval(x);
          $(prod).find("#countdown").addClass("d-none");
          
        }
      }, 1000);

      //var label = `<span class="product_tag_new">EXTRA 10%</span>`;
      //$(".product-item__label-list").append(label);
      
    } else{
      console.log("Time difference is more than 48 hours");
      document.getElementById("countdown").remove();
      document.getElementById("countDownTitle").remove();
      
    }
  }

 
  
}


$(document).ready(function(e){

  if ($("#promotions_disclaimer").length){

      var sku=$("#promotions_disclaimer").attr("data-sku");
      var language=$("#promotions_disclaimer").attr("data-language");
      
      $.get(ENDPOINT, {
        action: "bwgroup_campaign_by_sku",
        store: CHANNEL,
        sku: sku,
        language:language
      })
      .done(function (data) {
        console.log("CAMPANHA",data);
        if (data.status==1){
          if (data.output){
            $("#promotions_disclaimer span[data-start]").text(data.start)
            $("#promotions_disclaimer span[data-end]").text(data.end)
            $("#promotions_disclaimer").parent().children("p").remove()
            $("#promotions_disclaimer").show()
          } else {
            $("#promotions_disclaimer").parent().children("p").remove()
          }
          
        } else {
            $("#promotions_disclaimer").parent().children("p").remove()
        }
        
      })
      .fail(function (data) {
            $("#promotions_disclaimer").parent().children("p").remove()
      });
    
  }

})


// POP UP Z.INDEX
document.addEventListener('DOMContentLoaded', function() {
  const drawer = document.getElementById('mobile-menu-drawer');
  const sortPopover = document.getElementById('sort-by-popover');

  const widgetSelectors = [
    '[data-testid="app-router"]',
    'shopify-forms-embed',
    '[id^="app-embed-container"]',
    '.appEmbed',
  ];

  const isAnyOverlayOpen = () => {
    return (
      (drawer && drawer.hasAttribute('open')) ||
      (sortPopover && sortPopover.hasAttribute('open')) ||
      !!document.querySelector('quick-buy-popover[open]')
    );
  };

  const hideAll = () => {
    // Esconde widget 10% OFF
    widgetSelectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.style.setProperty('display', 'none', 'important');
      });
    });

    // Esconde reviews tab
    const reviewsTab = document.querySelector('.jdgm-revs-tab-btn');
    if (reviewsTab) reviewsTab.style.setProperty('display', 'none', 'important');

    // Esconde whatsapp
    const whatsapp = document.getElementById('whatsapp-widget-container');
    if (whatsapp) whatsapp.style.setProperty('display', 'none', 'important');
  };

  const showAll = () => {
    if (isAnyOverlayOpen()) return;

    // Mostra widget 10% OFF
    widgetSelectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.style.removeProperty('display');
      });
    });

    // Mostra reviews tab
    const reviewsTab = document.querySelector('.jdgm-revs-tab-btn');
    if (reviewsTab) reviewsTab.style.removeProperty('display');

    // Mostra whatsapp
    const whatsapp = document.getElementById('whatsapp-widget-container');
    if (whatsapp) whatsapp.style.removeProperty('display');
  };

  // Observa o drawer
  if (drawer) {
    new MutationObserver(() => {
      drawer.hasAttribute('open') ? hideAll() : showAll();
    }).observe(drawer, { attributes: true });

    document.querySelectorAll('[data-action="open-drawer"], .header__menu-button').forEach(btn => {
      btn.addEventListener('click', hideAll);
    });

    document.querySelectorAll('[data-action="close"]').forEach(btn => {
      btn.addEventListener('click', showAll);
    });
  }

  // Observa o sort-by-popover
  if (sortPopover) {
    new MutationObserver(() => {
      sortPopover.hasAttribute('open') ? hideAll() : showAll();
    }).observe(sortPopover, { attributes: true });
  }

  // Observa quick-buy-popover
  const observeQuickBuy = () => {
    document.querySelectorAll('quick-buy-popover').forEach(popover => {
      new MutationObserver(() => {
        popover.hasAttribute('open') ? hideAll() : showAll();
      }).observe(popover, { attributes: true });
    });
  };

  observeQuickBuy();

  // Quick-buy carregados dinamicamente
  new MutationObserver(() => {
    observeQuickBuy();
  }).observe(document.body, { childList: true, subtree: true });
});


(function () {
  function fixShopifyFormsEmbed() {
    var host = document.querySelector('#app-embed-container-981306');

    if (!host) return;

    host.style.setProperty('position', 'relative', 'important');
    host.style.setProperty('z-index', '3', 'important');

    if (host.shadowRoot) {
      var appEmbed = host.shadowRoot.querySelector('#app-embed');

      if (appEmbed) {
        appEmbed.style.setProperty('z-index', '3', 'important');
      }
    }
  }

  fixShopifyFormsEmbed();

  var formsEmbedObserver = new MutationObserver(function() {
    fixShopifyFormsEmbed();
    if (document.querySelector('#app-embed-container-981306')) {
      formsEmbedObserver.disconnect();
    }
  });

  formsEmbedObserver.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(function() {
    formsEmbedObserver.disconnect();
  }, 10000);
})();


const observer = new MutationObserver(() => {
  const embed = document.querySelector('shopify-forms-embed');

  if (!embed || !embed.shadowRoot) return;

  const appEmbed = embed.shadowRoot.querySelector('#app-embed');

  if (appEmbed) {
    appEmbed.style.setProperty('z-index', '3', 'important');

    observer.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


  function setupProductWishlistBtn() {
    function installProxy() {
      /* WISHLIST APENAS NA PÁGINA DE PRODUTO — NUNCA NO QUICK VIEW */
var productPage = document.querySelector(
  '.shopify-section--main-product > section'
);

if (!productPage) return false;

var originalTrigger = productPage.querySelector(
  '.wishlist-auto-injected .wishlist-trigger--inline, .product-meta__title .wishlist-trigger--inline'
);

var addToCart = productPage.querySelector('#AddToCart');

if (!originalTrigger || !addToCart) return false;
      if (document.querySelector('.wishlist-trigger--proxy')) return true;

      var proxy = originalTrigger.cloneNode(true);
      proxy.classList.remove('wishlist-trigger--inline', 'wishlist-initialized');
      proxy.classList.add('wishlist-trigger--proxy');
      proxy.style.cssText = 'display:flex; align-items:center; justify-content:center; width:44px; height:44px; min-width:44px; background:transparent; cursor:pointer; flex-shrink:0;';

      function syncProxy() {
        proxy.setAttribute('data-wishlisted', originalTrigger.getAttribute('data-wishlisted') || 'false');
        proxy.innerHTML = originalTrigger.innerHTML;
      }

      proxy.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        originalTrigger.click();
        window.setTimeout(syncProxy, 150);
        window.setTimeout(syncProxy, 600);
      });

      addToCart.insertAdjacentElement('afterend', proxy);
      addToCart.style.flex = '1';
      syncProxy();
      return true;
    }

    if (installProxy()) return;
    var observer = new MutationObserver(function() {
      if (installProxy()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupProductWishlistBtn);
  } else {
    setupProductWishlistBtn();
  }


  
  $(document).ready(function () {
  checkForBanner();
});

function checkForBanner() {
  if ($("#shopify-pc__banner").length) {
    onPopupAppear();
  } else {
    let observer = new MutationObserver(function (mutations, obs) {
      if ($("#shopify-pc__banner").length) {
        obs.disconnect();
        onPopupAppear();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}



  (function () {
    var SIZE_GUIDE_HASH = '#size-guide-modal';

    function openSizeGuideModal() {
      var trigger =
        document.querySelector('#SizeGuideModal-global [data-size-guide-open]') ||
        document.querySelector('[data-size-guide-open]');

      if (!trigger) return false;

      trigger.click();
      return true;
    }

    function handleSizeGuideHash() {
      if (window.location.hash !== SIZE_GUIDE_HASH) return;

      var attempts = 0;

      var interval = setInterval(function () {
        attempts++;

        if (openSizeGuideModal() || attempts >= 30) {
          clearInterval(interval);
        }
      }, 100);
    }

    function isSizeGuideLink(link) {
      if (!link || !link.getAttribute('href')) return false;

      try {
        var url = new URL(link.getAttribute('href'), window.location.href);
        return url.hash === SIZE_GUIDE_HASH;
      } catch (e) {
        return false;
      }
    }

    document.addEventListener('DOMContentLoaded', handleSizeGuideHash);
    window.addEventListener('hashchange', handleSizeGuideHash);

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a');

      if (!isSizeGuideLink(link)) return;

      event.preventDefault();
      event.stopPropagation();

      var currentUrl =
        window.location.pathname +
        window.location.search +
        SIZE_GUIDE_HASH;

      history.replaceState(null, '', currentUrl);

      handleSizeGuideHash();
    }, true);
  })();


  $(document).ready(function () {
  checkForBanner();
});

function checkForBanner() {
  if ($("#shopify-pc__banner").length) {
    onPopupAppear();
  } else {
    let observer = new MutationObserver(function (mutations, obs) {
      if ($("#shopify-pc__banner").length) {
        obs.disconnect();
        onPopupAppear();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}

function onPopupAppear() {
  var banner = $("#shopify-pc__banner");

  if (!banner.length) return;

  $("body").css("overflow", "hidden");

  if (!$("#shopify-cookie-backdrop").length) {
    $("body").append('<div id="shopify-cookie-backdrop"></div>');
  }

  $("#shopify-pc__banner__btn-accept").off("click.cookieBackdrop").on("click.cookieBackdrop", function () {
    $("#shopify-pc__banner__btn-manage-prefs").click();

    setTimeout(function () {
      $("#shopify-pc__prefs__dialog #shopify-pc__prefs__header-accept").click();
      removeCookieBackdrop();
    }, 150);
  });

  $("#shopify-pc__banner__btn-decline").off("click.cookieBackdrop").on("click.cookieBackdrop", function () {
    removeCookieBackdrop();
  });
}

function removeCookieBackdrop() {
  $("body").css("overflow", "auto");
  $("#shopify-cookie-backdrop").remove();
}





(function setupDynamicSizeGuideInitialisation() {
  function initialiseSizeGuides(root) {
    var sections = [];

    if (root && root.nodeType === 1 && root.matches('.sg-modal-section')) {
      sections.push(root);
    }

    if (root && root.querySelectorAll) {
      Array.prototype.push.apply(sections, root.querySelectorAll('.sg-modal-section'));
    }

    sections.forEach(function (section) {
      if (section.dataset.initialized === 'true') return;

      var script = section.nextElementSibling;
      var attempts = 0;

      while (script && script.tagName !== 'SCRIPT' && attempts < 3) {
        script = script.nextElementSibling;
        attempts++;
      }

      if (!script || script.tagName !== 'SCRIPT' || !script.textContent) return;

      window.__sizeGuideSectionToInitialize = section;

      try {
        var executable = document.createElement('script');
        executable.textContent = script.textContent;
        document.body.appendChild(executable);
        executable.remove();
      } finally {
        window.__sizeGuideSectionToInitialize = null;
      }
    });
  }

  function start() {
    initialiseSizeGuides(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          initialiseSizeGuides(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


(function connectQuickViewSizeGuideToGlobalModal() {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-size-guide-open]');
    if (!trigger) return;

    var quickView = trigger.closest('quick-buy-drawer, .drawer--quick-buy, [data-quick-buy-drawer]');
    if (!quickView) return;

    var globalTrigger = document.querySelector('#SizeGuideModal-global [data-size-guide-open]') ||
      document.querySelector('.shopify-section--main-product [data-size-guide-open]');

    if (!globalTrigger || globalTrigger === trigger) return;

    var globalContainer = globalTrigger.closest('.global-size-guide-modal');
    if (globalContainer && globalContainer.parentNode !== document.body) {
      document.body.appendChild(globalContainer);
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    globalTrigger.click();
  }, true);
})();


/* PRODUCT PAGE — ATUALIZAR SOLD OUT AO TROCAR VARIANTE */
document.addEventListener('variant:changed', function(event) {

  var variant = event.detail && event.detail.variant;
  if (!variant) return;

  function syncSoldOutBadge() {

    var badge = document.querySelector(
      '.shopify-section--main-product .product-page-sold-out-badge'
    );

    if (!badge) return;

    if (variant.available) {
      badge.style.setProperty('display', 'none', 'important');
    } else {
      badge.style.setProperty('display', 'inline-flex', 'important');
    }
  }

  syncSoldOutBadge();

  /* garante que corre depois da atualização do tema */
  window.setTimeout(syncSoldOutBadge, 50);
  window.setTimeout(syncSoldOutBadge, 250);

});

/* =========================================================
   COLLECTION DESKTOP — SIZE QUICK ADD / NOTIFY ME
   ========================================================= */
(function () {

  function getDesktopSizeVariant(productItem, sizeValue) {
    var dataElement = productItem.querySelector('.product-item__variant-stock');

    if (!dataElement) return null;

    var data;

    try {
      data = JSON.parse(dataElement.textContent);
    } catch (error) {
      return null;
    }

    if (!data.options || !data.variants) return null;

    var sizeIndex = -1;
    var colorIndex = -1;

    data.options.forEach(function (optionName, index) {
      var normalised = typeof normaliseVariantOptionName === 'function'
        ? normaliseVariantOptionName(optionName)
        : String(optionName || '').toLowerCase();

      if (normalised === 'size') sizeIndex = index;
      if (normalised === 'color') colorIndex = index;
    });

    if (sizeIndex === -1) return null;

    var selectedColor = null;

    if (colorIndex !== -1) {
      var checkedColor = productItem.querySelector(
        '.product-item-meta__swatch-list .color-swatch__radio:checked'
      );

      if (checkedColor) {
        selectedColor = checkedColor.value;
      }
    }

    return data.variants.find(function (variant) {
      if (!variant.options) return false;

      var sizeMatches =
        String(variant.options[sizeIndex]) === String(sizeValue);

      if (!sizeMatches) return false;

      if (
        colorIndex !== -1 &&
        selectedColor !== null &&
        String(variant.options[colorIndex]) !== String(selectedColor)
      ) {
        return false;
      }

      return true;
    }) || null;
  }


  function refreshDesktopSizePicker(productItem) {
    if (!productItem) return;

    productItem.querySelectorAll(
      '.product-item__desktop-size'
    ).forEach(function (button) {

      var variant = getDesktopSizeVariant(
        productItem,
        button.dataset.sizeValue
      );

      button.classList.toggle(
        'is-sold-out',
        !!variant && variant.available === false
      );

      if (variant && variant.id) {
        button.dataset.variantId = variant.id;
      } else {
        button.removeAttribute('data-variant-id');
      }

    });
  }


  function refreshAllDesktopSizePickers(root) {
    if (window.innerWidth < 1000) return;

    (root || document)
      .querySelectorAll('.shopify-section--main-collection .product-item')
      .forEach(refreshDesktopSizePicker);
  }


  function goToSoldOutVariant(productItem, variantId) {
  var productLink = productItem.querySelector('.product-item__aspect-ratio');

  if (!productLink) return;

  var url = new URL(productLink.href, window.location.origin);
  url.searchParams.set('variant', variantId);

  window.location.href = url.toString();
}

function showOriginalCartNotification() {
  var notification = document.querySelector(
    'cart-notification[global]'
  );

  if (!notification) return;

  notification.hidden = false;

  window.clearTimeout(notification._gkHideTimer);

  notification._gkHideTimer = window.setTimeout(function () {
    notification.hidden = true;
  }, 2500);
}

document.addEventListener('click', function (event) {

    var button = event.target.closest(
      '.shopify-section--main-collection .product-item__desktop-size'
    );

    if (!button || window.innerWidth < 1000) return;

    event.preventDefault();
    event.stopPropagation();

    var productItem = button.closest('.product-item');

    if (!productItem) return;

    var variant = getDesktopSizeVariant(
      productItem,
      button.dataset.sizeValue
    );

    if (!variant || !variant.id) return;


    /* SEM STOCK → abrir Quick View diretamente na variante */
    if (variant.available === false) {

      goToSoldOutVariant(productItem, variant.id);

      return;
    }


    /* COM STOCK → usar o Product Form nativo do tema */
var nativeForm = productItem.querySelector(
  '.product-item__desktop-size-form'
);

if (!nativeForm) return;

var variantInput = nativeForm.querySelector(
  'input[name="id"]'
);

if (!variantInput) return;

variantInput.value = String(variant.id);

button.classList.add('is-loading');

var removeLoading = function () {
  button.classList.remove('is-loading');
  document.removeEventListener('variant:added', removeLoading);
};

document.addEventListener('variant:added', removeLoading);

nativeForm.requestSubmit();

window.setTimeout(function () {
  button.classList.remove('is-loading');
  document.removeEventListener('variant:added', removeLoading);
}, 4000);

  }, true);


  /* Se o cliente mudar a cor, recalcular stock dos tamanhos */
  document.addEventListener('change', function (event) {

    if (!event.target.matches(
      '.shopify-section--main-collection .color-swatch__radio'
    )) return;

    var productItem = event.target.closest('.product-item');

    window.setTimeout(function () {
      refreshDesktopSizePicker(productItem);
    }, 0);

  });


  /* Produtos iniciais */
  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', function () {
      refreshAllDesktopSizePickers(document);
    });

  } else {

    refreshAllDesktopSizePickers(document);

  }


  /* Produtos que entram pelo infinite scroll */
  document.addEventListener(
    'collection:products:appended',
    function () {
      refreshAllDesktopSizePickers(document);
    }
  );

})();